// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { OrganizationInternalOwnerDTO } from '../models';
/**
 * OrganizationInternalOwnersApi - axios parameter creator
 * @export
 */
export const OrganizationInternalOwnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all internal owners for an Organization
         * @param {string} organizationId Organization id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwners(organizationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling getOwners.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/internal-owners`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationInternalOwnersApi - functional programming interface
 * @export
 */
export const OrganizationInternalOwnersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get all internal owners for an Organization
         * @param {string} organizationId Organization id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwners(organizationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationInternalOwnerDTO>> {
            const localVarAxiosArgs = OrganizationInternalOwnersApiAxiosParamCreator(configuration).getOwners(organizationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrganizationInternalOwnersApi - factory interface
 * @export
 */
export const OrganizationInternalOwnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get all internal owners for an Organization
         * @param {string} organizationId Organization id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwners(organizationId: string, options?: any) {
            return OrganizationInternalOwnersApiFp(configuration).getOwners(organizationId, options)(axios, basePath);
        },
    };
};

/**
 * OrganizationInternalOwnersApi - interface
 * @export
 * @interface OrganizationInternalOwnersApi
 */
export interface OrganizationInternalOwnersApiInterface {
    /**
     * Get all internal owners for an Organization
     * @param {string} organizationId Organization id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInternalOwnersApiInterface
     */
    getOwners(organizationId: string, options?: any): AxiosPromise<Array<OrganizationInternalOwnerDTO>>;

}

/**
 * OrganizationInternalOwnersApi - object-oriented interface
 * @export
 * @class OrganizationInternalOwnersApi
 * @extends {BaseAPI}
 */
export class OrganizationInternalOwnersApi extends BaseAPI implements OrganizationInternalOwnersApiInterface {
    /**
     * Get all internal owners for an Organization
     * @param {string} organizationId Organization id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationInternalOwnersApi
     */
    public getOwners(organizationId: string, options?: any) {
        return OrganizationInternalOwnersApiFp(this.configuration).getOwners(organizationId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrganizationInternalOwnersApi
 * Import individual functions for optimal bundle size
 */
/**
 * Get all internal owners for an Organization
 * @param {string} organizationId Organization id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getOwners(
    organizationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<OrganizationInternalOwnerDTO>> {
    const localVarAxiosArgs = OrganizationInternalOwnersApiAxiosParamCreator(configuration).getOwners(organizationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

